import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import CheckValue from "../../../../Utils/CheckValue/CheckValue";

export default function Change({ symbol_id, type }) {
  const socket = useContext(SocketContext);
  const [change, setChange] = useState(0);
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);

    const tradeListener = (data) => {
      if (data && data.LTP != null && data.Previous_Close != null) {
        const ch = data.LTP - data.Previous_Close;
        const pct = (ch / data.Previous_Close) * 100;
        setChange(ch);
        setPercent(pct);
        // if (type === "crypto_future" || type === "forex_future") {
        //   setChange(data.Net_Change);
        //   setPercent(data.Percentage_Change);
        // } else {

        // }
      }
    };

    socket.on(`trade${symbol_id}`, tradeListener);

    return () => {
      socket.off(`trade${symbol_id}`, tradeListener);
    };
  }, [socket, symbol_id]);

  let formatted = "0.00 (0%)";
  try {
    if (type === "forex_future") {
      formatted = `${change.toFixed(change < 1 ? 5 : 2)} (${percent.toFixed(
        2
      )}%)`;
    } else {
      formatted = `${change.toFixed(2)} (${percent.toFixed(2)}%)`;
    }
  } catch {
    formatted = "0.00 (0%)";
  }

  return (
    <div className="menuNetChnage addFlex">
      <CheckValue number={formatted} extra={"AddFontSize"} />
    </div>
  );
}
